module.exports = __webpack_public_path__ + "static/popup-br-4812dde9ee72bfa8db0d9fff4e3f8c72.png";